export enum EDatasourceType {
  CLICKHOUSE = 'clickhouse',
}
